export default "__VITE_ASSET__nOgSVRc$__"